import config from '../config';
import {PhoneNumberUtil} from 'google-libphonenumber';
const phoneUtil = new PhoneNumberUtil();
import moment from 'moment';

export const formatCartItemText = (text) => {
  if(!text){
    return '';
  }
  return text.slice(0, config.cartItemTextMaxLength);
};
export const formatCartItemTextSM = (text) => {
    if(!text){
    return '';
  }
  return text.slice(0, config.cartItemSMTextMaxLength);
};

export const formatVkLoginSessionObj = (session) => ({
  token: session.session.session.user.id,
  type: config.vkAuth
});

export const formatVkRegisterSessionObj = (session) => ({
  token: session.session.session.user.id,
  type: config.vkAuth,
  userdata: {
    email: session.oAuth.email,
    firstname: session.session.session.user.first_name,
    lastname: session.session.session.user.last_name
  }
});

export const formatFbLoginSessionObj = (session) => ({
  access_token: session.profile.id,
  type: config.fbAuth
});

export const formatFbRegisterSessionObj = (session) => ({
  token: session.profile.id,
  type: config.fbAuth,
  userdata: {
    firstname: session.profile.name.split(' ')[0],
    lastname: session.profile.name.split(' ')[1],
    email: session.profile.email
  }
});

export const extractNumbers = (text) => '' + text.replace( /[^\d.]/g, '' );
export const formatPhoneNumber = (number) => '+' + extractNumbers(number);

export const isValidNumber = (number) => {
  const extractedNumber = '+' + extractNumbers(number);
  try {
    const parsedNumber = phoneUtil.parse(extractedNumber);
    phoneUtil.isValidNumber(parsedNumber);
    return true;
  } catch (err) {
    return false;
  }
};

/**
 * Password life time
 */
export const setPasswordTimer = () => {
  const timeWhenPasswordResendIsPossible = canResetPasswordResendTimestamp()
    ? +moment().add(config.timeWhenPasswordResendIsPossible).format('x')
    : getPasswordResendTimestamp();

    canResetPasswordResendTimestamp() && setPasswordResendTimestamp(timeWhenPasswordResendIsPossible);
};

export const canResetPasswordResendTimestamp = () => {
  return moment().format('x') >= getPasswordResendTimestamp();
};

export const setPasswordResendTimestamp = (timestamp) => {
  localStorage.setItem('pswd_rsnd_tmstmp', timestamp);
};

export const getPasswordResendTimestamp = () => {
  return +localStorage.getItem('pswd_rsnd_tmstmp');
};
/** */

export const geocode = ({city = '', state = '', road = '', house_number = ''}, cb) => {
  if (!window.google) {
    //todo add error handling
    return console.error('no window.google');
  }
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({
    address: `${city || state} ${road} ${house_number}`
  }, cb);
};

export const getFormattedTimeLeftUntilPasswordResendIsPossible = () =>
  moment(moment(getPasswordResendTimestamp()).diff(+moment().format('x'))).format('m:ss');


export const formatPriceText = (text) => ('' + text).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");

export const getScreenWidth = () => window.innerWidth ||
                      document.documentElement.clientWidth ||
                      document.body.clientWidth ||
                      document.body.offsetWidth;

export const isDesktop = () => getScreenWidth() > 580; //1024

export const getIdByURL = () => document.location.href.split('/').slice(-1)[0];

export const declinationByNumber = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
};

export function compareValue(value, filterBy) {
  return value && value.toString().toLowerCase().indexOf(filterBy.toLowerCase()) != -1;
}



/** WEBPACK FOOTER **
 ** ./src/logic/utils.js
 **/